<template>
  <div class="content-cls">
    <p style="font-size:12pt; line-height:150%; margin:0pt; orphans:0; text-align:center; widows:0"><span
      style="font-family:宋体; font-size:12pt">知识群聊使用协议</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">默往APP</span>
      <span
        style="font-family:宋体; font-size:11pt">的知识群聊服务由</span><span
        style="font-family:宋体; font-size:11pt">厦门默往科技有限公司（下称“默往”）</span><span
        style="font-family:宋体; font-size:11pt">基于本知识群聊使用协议而提供</span><span
        style="font-family:宋体; font-size:11pt">。</span><span
        style="font-family:宋体; font-size:11pt">请仔细阅读。</span><span
        style="font-family:宋体; font-size:11pt">默往</span><span
        style="font-family:宋体; font-size:11pt">向您（或称</span><span
        style="font-family:Calibri; font-size:11pt">“</span><span
        style="font-family:宋体; font-size:11pt">用户</span><span
        style="font-family:Calibri; font-size:11pt">”</span><span
        style="font-family:宋体; font-size:11pt">）提供的</span><span
        style="font-family:宋体; font-size:11pt">知识群聊</span><span
        style="font-family:宋体; font-size:11pt">服务还需要您遵守其他条款及服务准则（包括但不限于</span><span
        style="font-family:宋体; font-size:11pt">默往平台用户协议</span><span
        style="font-family:宋体; font-size:11pt">、服务说明及使用帮助等，简称</span><span
        style="font-family:Calibri; font-size:11pt">“</span><span
        style="font-family:宋体; font-size:11pt">其他规则</span><span
        style="font-family:Calibri; font-size:11pt">”</span><span
        style="font-family:宋体; font-size:11pt">），您应同时阅读了解并予以一并接受。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">1.</span><span
      style="font-family:宋体; font-size:11pt">特别声明</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">1.1</span><span
      style="font-family:宋体; font-size:11pt">您同意本</span><span
      style="font-family:宋体; font-size:11pt">协议</span><span
      style="font-family:宋体; font-size:11pt">的方式包括但不限于：  </span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">1)</span><span
      style="font-family:Calibri; font-size:11pt">  </span><span
      style="font-family:宋体; font-size:11pt">在使用本知识群聊功能前</span><span
      style="font-family:宋体; font-size:11pt">点击表示同意的相应按钮；</span></p>
    <p
      style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
      <span style="font-family:Calibri; font-size:11pt">2)</span><span
      style="font:7.0pt 'Times New Roman'">&#xa0; </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">通过电子邮件、电话、传真、即时通信</span>
      <span
        style="font-family:宋体; font-size:11pt">、默往公告</span>
      <span
        style="font-family:宋体; font-size:11pt">等方式所作的口头或书面表示；</span>
    </p>
    <p
      style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
      <span style="font-family:Calibri; font-size:11pt">3)</span><span
      style="font:7.0pt 'Times New Roman'">&#xa0; </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">成为</span><span
      style="font-family:宋体; font-size:11pt">知识群聊群主或群成员</span><span
      style="font-family:宋体; font-size:11pt">，使用</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">的相应功能或服务；</span>
    </p>
    <p
      style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
      <span style="font-family:Calibri; font-size:11pt">4)</span><span
      style="font:7.0pt 'Times New Roman'">&#xa0; </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">其他您与</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">均认可的方式。</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">1.</span><span
      style="font-family:Calibri; font-size:11pt">2</span><span
      style="font-family:宋体; font-size:11pt">本</span><span
      style="font-family:宋体; font-size:11pt">协议</span><span
      style="font-family:宋体; font-size:11pt">将构成您与</span><span
      style="font-family:宋体; font-size:11pt">厦门默往</span><span
      style="font-family:宋体; font-size:11pt">科技有限公司以及与本软件及本服务开发、运营的关联方（以下合称</span><span
      style="font-family:Calibri; font-size:11pt">“</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:Calibri; font-size:11pt">”</span><span
      style="font-family:宋体; font-size:11pt">）之间直接有约束力的法律文件。</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">有权在必要时修改本</span><span
      style="font-family:宋体; font-size:11pt">协议</span><span
      style="font-family:宋体; font-size:11pt">条款。您可以在本软件的最新版本中查阅相关</span><span
      style="font-family:宋体; font-size:11pt">协议</span><span
      style="font-family:宋体; font-size:11pt">条款。如本协议与本软件或本服务的实际功能设定有冲突的，以实际功能设定为准。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.</span><span
      style="font-family:宋体; font-size:11pt">服务内容及规范  </span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.</span><span
      style="font-family:Calibri; font-size:11pt">1</span><span
      style="font-family:宋体; font-size:11pt">服务内容</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">知识群聊服务</span><span
      style="font-family:宋体; font-size:11pt">为</span><span
      style="font-family:宋体; font-size:11pt">用户提供群产品与服务</span><span
      style="font-family:宋体; font-size:11pt">。您了解并同意，</span><span
      style="font-family:宋体; font-size:11pt">知识群聊服务</span><span
      style="font-family:宋体; font-size:11pt">是为特定用户向符合条件的其他用户分享、交流及推广</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">或相关经验内容</span><span
      style="font-family:宋体; font-size:11pt">的</span><span
      style="font-family:宋体; font-size:11pt">技术服务。</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">通过</span><span
      style="font-family:宋体; font-size:11pt">知识群聊所</span><span
      style="font-family:宋体; font-size:11pt">提供的技术服务招揽符合条件的其他用户进入由</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">建立并设置相关活动规则的</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">，并承担相关</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">的管理责任。</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">与其他</span><span
      style="font-family:宋体; font-size:11pt">群成员</span><span
      style="font-family:宋体; font-size:11pt">之间根据本协议及相关规则，以及具体</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">的活动规则达成相应的服务协议，进入</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">的相关用户应遵从相应</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">的管理。各方均应按照服务协议的约定全面履行相应义务，如各方因履行服务协议而导致任一方遭受相关财产及人身损害的，遭受损害的一方应直接向对方索赔。</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">免于承担成员与</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主双方之间因实际服务协议履行所致任何纠纷的赔偿责任。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.1.1</span><span
      style="font-family:宋体; font-size:11pt">创建</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">及邀请</span><span
      style="font-family:宋体; font-size:11pt">群成员</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">应根据</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">公布并更新的《</span><span
      style="font-family:宋体; font-size:11pt">知识群聊使用协议</span><span
      style="font-family:宋体; font-size:11pt">》进行审核登记并承诺遵从《</span><span
      style="font-family:宋体; font-size:11pt">知识群聊使用协议</span><span
      style="font-family:宋体; font-size:11pt">》的规范要求。</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">通过</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">的审核和登记后，即可按照</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">的平台规则要求建立并管理</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">，并在遵从</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">相关规则的前提下自主设置该</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">的准入条件。</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">对</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">内的活动承担相应的管理责任。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">可根据需求邀请</span><span
      style="font-family:宋体; font-size:11pt">成员</span><span
      style="font-family:宋体; font-size:11pt">加入</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">共同为成员提供服务，相关</span><span
      style="font-family:宋体; font-size:11pt">群成员</span><span
      style="font-family:宋体; font-size:11pt">的服务范围、服务内容及相应报酬的结算方式应由</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主与</span><span
      style="font-family:宋体; font-size:11pt">群成员</span><span
      style="font-family:宋体; font-size:11pt">自行约定，但该等约定不应违反相关法律法规、本协议及相关规则的约定，且</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">应对</span><span
      style="font-family:宋体; font-size:11pt">群成员</span><span
      style="font-family:宋体; font-size:11pt">的行为法律后果承担连带责任。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">应按照《</span><span
      style="font-family:宋体; font-size:11pt">知识群聊使用协议</span><span
      style="font-family:宋体; font-size:11pt">》的要求及时缴纳相应服务费用，如</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">对</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">负有任何债务的，</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">有权在</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">的</span><span
      style="font-family:宋体; font-size:11pt">余额款项中</span><span
      style="font-family:宋体; font-size:11pt">予以事先扣除。同时，</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">承诺其应就在</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">上所获得的所有收入依法缴纳相关税费。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.1.2 </span><span
      style="font-family:宋体; font-size:11pt">加入</span><span
      style="font-family:宋体; font-size:11pt">群聊</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">您可以在</span><span
      style="font-family:宋体; font-size:11pt">默往里</span><span
      style="font-family:宋体; font-size:11pt">访寻并加入您感兴趣的</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">，以便获得</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主向其</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">成员分享的</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">、经验及相关内容。您了解并同意，</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主有权对其成员自行设立准入条件，包括但不限于需要支付相应的加入费用，遵守</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主发布的包括但不限于</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">内活动规范及收退费等具体规则。在加入相关</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">后，您应同时遵守相应法律法规、本协议、</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">相关规则、</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主针对</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">发布的具体规则，且</span><span
      style="font-family:宋体; font-size:11pt">群</span><span
      style="font-family:宋体; font-size:11pt">主针对</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">发布的具体规则应优先适用，如果</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">没有制定</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">规则</span><span
      style="font-family:宋体; font-size:11pt">或者群聊</span><span
      style="font-family:宋体; font-size:11pt">规则约定不清的，则应适用</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">相关规则。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">作为技术服务平台，</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">不会主动对</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">及其邀请的</span><span
      style="font-family:宋体; font-size:11pt">群成员</span><span
      style="font-family:宋体; font-size:11pt">内所发布的知识、经验及相关内容进行核查，也不对</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">及其邀请的</span><span
      style="font-family:宋体; font-size:11pt">群成员</span><span
      style="font-family:宋体; font-size:11pt">所提供服务的效果能否满足您的预期作出保证。您应自行谨慎判断对方是否具有相关服务资质及履约能力并自行决定是否加入</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">以享受该</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">所提供的服务，且您应自行承担与此相关的所有风险。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">您理解并同意，鉴于虚拟服务的特性，您应特别注意对拟加入</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">的付费及退费规则的全部理解和遵守。</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">有权将其所提供的服务有效期自其设置该等</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">的付费金额和付费方式之日起开始计算，且有权规定具体的退费规则，请您在申请加入付费</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">前请仔细核对并确认</span><span
      style="font-family:宋体; font-size:11pt">群聊</span><span
      style="font-family:宋体; font-size:11pt">的付费金额、剩余服务有限期限和退费规则，您一经购买即视为您已了解并同意接受以该等付费金额和付费方式享有</span><span
      style="font-family:宋体; font-size:11pt">群主</span><span
      style="font-family:宋体; font-size:11pt">所提供的对应服务。 </span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.1.3 </span>
     ><span
        style="font-family:宋体; font-size:11pt">服务</span>
      <span
        style="font-family:宋体; font-size:11pt">费</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">针对</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">及</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">合作的第三方机构向您提供的</span><span
      style="font-family:宋体; font-size:11pt">知识产权群聊</span><span
      style="font-family:宋体; font-size:11pt">服务，</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">将按照明确的服务规则</span>
      <span
        style="font-family:宋体; font-size:11pt">扣除相关第三方支付手续费以后</span>
      <span
        style="font-family:宋体; font-size:11pt">向您收取</span>
      <span
        style="font-family:Calibri; font-size:11pt">50</span>
      <span
        style="font-family:Calibri; font-size:11pt">%</span>
      <span
        style="font-family:宋体; font-size:11pt">的服务</span>
      <span
        style="font-family:宋体; font-size:11pt">费。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.2</span><span
      style="font-family:宋体; font-size:11pt">知识群聊服务的修改和终止</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">始终在不断更改和改进其所提供的服务。</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">可能会增加或删除某项服务功能，也可能暂停或彻底停止某项服务。您可以随时停止使用</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">的服务，</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">也可能随时停止向您提供服务，或随时对</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">的服务增加或设置新的限制。但是，如果</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">停止某项服务或增加或设置于您而言更为严格的限制时，则</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">会向您发出合理的提前通知，并让您有机会备份和转移其留存在本服务中的信息。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.2.1</span><span
      style="font-family:宋体; font-size:11pt">如您违反其在本协议中的行为规范的，默往有权随时终止向您提供所述服务，同时根据违规程度的轻重进行不同处罚，具体处罚措施包括但不限于：封禁知识群聊、扣除全部或部分群成员进群费用等其他限制知识群聊、群主或群成员措施。</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">1</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得进行虚假交易、非法套现、洗钱等行为；</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得直接或变相从事互联网赌博、色情行为；</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">3</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得直接或变相从事互联网销售彩票行为；</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">4</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得直接或变相从事非法外汇、贵金属投资交易，非法证券期货类交易；</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">5</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得直接或变相从事代币发行融资及虚拟货币交易；</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">6</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得未经监管部门批准开展资产管理业务以及未取得省级政府批文的大宗商品交易等非法</span><span
      style="font-family:宋体; font-size:11pt">交易</span><span
      style="font-family:宋体; font-size:11pt">；</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">7</span><span
      style="font-family:Calibri; font-size:11pt">)</span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">不得未取得相应资质直接或变相从事互联网新闻信息服务、法定特许或者应予以备案的金融业务，不得制作、复制、发布、传播法定禁止的金融信息内容；</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">8</span><span
      style="font-family:Calibri; font-size:11pt">) </span><span
      style="font-family:Calibri; font-size:11pt"> </span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">有权对</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">的违法违规行为，依据程度采取</span>
      <span
        style="font-family:宋体; font-size:11pt">封群封号等</span>
      <span
        style="font-family:宋体; font-size:11pt">相应处置措施，处置方式包括但不限于内容处置、终止服务</span>
     <span
        style="font-family:宋体; font-size:11pt">、</span>
      <span
        style="font-family:宋体; font-size:11pt">终止知识群主分成结算</span>
      <span
        style="font-family:宋体; font-size:11pt">，同时</span><span
        style="font-family:宋体; font-size:11pt">默往</span><span
        style="font-family:宋体; font-size:11pt">也将保留进一步追究相关法律责任的权利。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">2.2.2 </span><span
      style="font-family:宋体; font-size:11pt">用户在默往知识群聊发布侵犯他人知识产权或其他合法权益的内容，默往有权予以删除，并保留移交司法机关处理的权利。个人或单位如认为默往知识群聊上存在侵犯自身合法权益的内容，应准备好具有法律效应的证明材料，及时与默往取得联系，以便默往迅速做出处理。</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">3.</span><span
      style="font-family:宋体; font-size:11pt">有限责任</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">3.1</span><span
      style="font-family:宋体; font-size:11pt">您理解并确认，</span><span
      style="font-family:宋体; font-size:11pt">默往</span><span
      style="font-family:宋体; font-size:11pt">需要定期或不定期地对</span><span
      style="font-family:宋体; font-size:11pt">知识群聊</span><span
      style="font-family:宋体; font-size:11pt">或</span><span
      style="font-family:宋体; font-size:11pt">相关的功能</span><span
      style="font-family:宋体; font-size:11pt">进行</span><span
      style="font-family:宋体; font-size:11pt">维护</span><span
      style="font-family:宋体; font-size:11pt">或者</span><span
      style="font-family:宋体; font-size:11pt">升级</span><span
      style="font-family:宋体; font-size:11pt">，如因此类情况而造成服务在合理时间内的中断，我们无需为此承担任何责任。</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">3.2</span><span
      style="font-family:宋体; font-size:11pt">默往不对您所发布或提供的数据信息的保存、修改、删除或储存失败负责。默往可以根据相关法律规定及服务的实际情况自行决定您在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本服务中的相关数据。您在此明确同意并接受，除非法律另有规定，如您停止使用本服务或本服务终止或您的默往账户被收回的，默往可以从服务器上永久地删除您的全部数据。本服务终止后，我们没有义务向您返还任何数据。</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">4.</span><span
      style="font-family:宋体; font-size:11pt">其他</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">4.1</span><span
      style="font-family:宋体; font-size:11pt">本协议是《用户协议》的一部分，本协议与默往《用户协议》不一致的，以本协议为准；本协议没有规定的，按照《用户协议》执行。</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">4.2</span><span
      style="font-family:宋体; font-size:11pt">本协议其他条款未明示授权的其他一切权利仍由我们保留，您在行使这些权利时须另外取得我们的书面许可。我们如果未行使前述任何权利，并不构成对该权利的放弃。</span>
    </p>
    <p style="font-size:11pt; line-height:150%; margin:0pt; orphans:0; text-align:justify; widows:0"><span
      style="font-family:Calibri; font-size:11pt">&#xa0;</span></p>
  </div>

</template>
<script>
export default {
  name: 'knowledge',
  created () {
    document.title = '知识群聊协议'
  }
}
</script>

<style lang="scss" scoped>
.content-cls {
  line-height: 2;
  padding: 10px 20px;
  font-size: 15px;
  >p {
    line-height: 2 !important;
  }
}
</style>
